import { useState } from 'react';
import React from "react";
import { login } from "./utils.js";
import "./login.css";

export default function Login({ setIsLoggedIn }) {
  const [enteredToken, setEnteredToken] = useState();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = await login(enteredToken);
    if (isValid) {
      setIsLoggedIn(true);
    } else {
      alert("Invalid token");
    }
  };

  return (
    <div className="login-wrapper">
      <h1>Access token</h1>
      <form onSubmit={handleSubmit}>
        <label>
          <input type="text" className="login-input" onChange={(e) => setEnteredToken(e.target.value)} />
        </label>
        <div className="submit-btn">
          <button type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
}
